import { emptyField, invalidEmail } from '@/lib/validation/ErrorMessages'
import { FieldValues } from 'react-hook-form'
import * as Yup from 'yup'

export interface RecoveryPasswordFormData extends FieldValues {
  email: string
}

const PasswordRecoveryFormSchema = Yup.object().shape({
  email: Yup.string().email(invalidEmail).required(emptyField),
})

export default PasswordRecoveryFormSchema
